import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const VaccinesIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7,22.5c0.6,0,1-0.5,1-1V17h1c1.1,0,2-0.9,2-2V7.5c0.6,0,1-0.4,1-1s-0.4-1-1-1H8V4h0.5c0.6,0,1-0.5,1-1s-0.4-1-1-1h-3c-0.6,0-1,0.5-1,1s0.4,1,1,1H6v1.5H3c-0.5,0-1,0.4-1,1s0.5,1,1,1V15c0,1.1,0.9,2,2,2h1v4.5C6,22,6.4,22.5,7,22.5zM9,9H7.2C6.8,9,6.5,9.3,6.5,9.8s0.3,0.8,0.8,0.8H9V12H7.2c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8H9V15H5V7.5h4V9z M19.5,10.5V10c0.5,0,1-0.4,1-1s-0.5-1-1-1h-5c-0.6,0-1,0.4-1,1s0.4,1,1,1v0.5c0,0.5-1.5,1.2-1.5,3V20c0,1.1,0.9,2,2,2h4c1.1,0,2-0.9,2-2v-6.5C21,11.7,19.5,11,19.5,10.5z M16.5,10.5V10h1v0.5c0,1.6,1.5,2,1.5,3V14h-4c0-0.2,0-0.4,0-0.5C15,12.5,16.5,12.1,16.5,10.5z M15,20c0,0,0-0.6,0-1.5h4V20H15z"
        fill={color}
      />
    </IconBase>
  );
};

export default VaccinesIcon;
